import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import './Header.css';

function Header() {
  // État pour gérer l'ouverture/fermeture du dropdown
  const [isOpen, setIsOpen] = useState(false);

  // Fonction pour basculer l'état du dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  

  return (
    <header className="header-basic">
      <div className="header-content">
        <div className="left-section">
          <span className="location">
            <i className="fas fa-map-marker-alt"></i> <strong>Agadir(Siège)</strong>
          </span>
          <span className="contact">
            <i className="fas fa-phone-alt"></i><strong>+212 6 55 76 00 51</strong> 
          </span>
          <span className="email">
            <i className="fas fa-envelope"></i> <strong>Biocleanersservices@service.com</strong>
          </span>
        </div>
        
        <div className="right-section">
          <a href="https://www.instagram.com/bio_cleaners_services/" className="social-icon"><i className="fab fa-instagram"></i></a>
          <a href="https://www.tiktok.com/@bio_cleaners" className="social-icon"><i className="fab fa-tiktok"></i></a>
          <a href="https://wa.me/212655760051" className="social-icon"><i className="fab fa-whatsapp"></i></a>

          {/* Menu dropdown */}
          <div className="dropdown">
            <button onClick={toggleDropdown} className="dropbtn">
              <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
            </button>
            {isOpen && (
              <div className="dropdown-content">
                <Link to="/">Acceuil</Link>
                <Link to="/AboutUs">À propos</Link>
                <Link to="/Services">Services</Link>
                <Link to="/Contact">Contact</Link>
                <Link to="/Book">Réservation</Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
